import {chain} from "../../utils/fs";

export const resolveErrorMessage = (value, validators) => chain(
    validators.find(({validate}) => !validate(value)),
    (v) => (
        !v ? (
            null
        ) : v.getMessage ? (
            v.getMessage(value)
        ) : (
            v.message ??
            ({
                "required": "Required",
                "url-format": "Invalid URL format",
                "not-blank": "Required",
            })[v.name] ??
            v.name
        )
    ),
);
